import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.showNativeShareForCurrentOS)
    ? (_openBlock(), _createElementBlock("button", {
        key: "showNativeShareForCurrentOS",
        class: "c-magic-line text-dusty-grey",
        type: "button",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.shareWishListLink()), ["prevent"]))
      }, _toDisplayString(_ctx.shareButtonText), 1))
    : _renderSlot(_ctx.$slots, "default", { key: "showFallbackShareButton" })
}